import { render } from "./ReportProblemModal.vue?vue&type=template&id=8c27d096"
import script from "./ReportProblemModal.vue?vue&type=script&lang=js"
export * from "./ReportProblemModal.vue?vue&type=script&lang=js"
script.render = render

export default script